module.exports = __webpack_public_path__ + "img/berlinerkranse_done.400cbfb6.jpg";